import form from "./form";


const {
    formField: {
        code,
        key
    },
} = form;

const initialValues = {
    [code.name]: "",
    [code.name]: ""
};

export default initialValues;
